/* -------------------------------------------------------------------------- */
/*                               Schema Schedules                             */
/* -------------------------------------------------------------------------- */

import { schema } from 'normalizr';

export const schedule = new schema.Entity('schedules', {}, { idAttribute: 'scheduleId' });
export const schedules = new schema.Array(schedule);
